import React, { createContext, useContext, useState, useEffect, Children } from 'react';

const DomainNameContext = createContext();

export const useDomain = () => useContext(DomainNameContext);
export const DomainNameProvider = ({children}) => {
    const [domain, setDomain] = useState('');

    useEffect(() => {
        const currentDomain = window.location.hostname;
        setDomain(currentDomain);
    }, []);

    return (
        <DomainNameContext value={domain}>
            {children}
        </DomainNameContext>
    );
}